<script setup lang="ts">
import { computed } from 'vue';
import {
  DxDataGrid,
  DxColumn,
  DxSorting,
  DxExport,
} from 'devextreme-vue/data-grid';
import { bottoGridPaging } from '@botto/core';
import { columnsFromRows, normalizeToRows } from '../utils/gridData';

const { paging, pager } = bottoGridPaging();

const props = defineProps<{
  data: unknown;
  loading?: boolean;
}>();

const rows = computed(() => normalizeToRows(props.data));
const columns = computed(() => columnsFromRows(rows.value));
</script>

<template>
  <DxDataGrid
    :data-source="rows"
    :show-borders="true"
    :row-alternation-enabled="true"
    :column-auto-width="true"
    :disabled="loading"
    :paging="paging"
    :pager="pager"
  >
    <DxSorting mode="multiple" />
    <DxExport :enabled="true" />
    <DxColumn
      v-for="col in columns"
      :key="col.dataField"
      :data-field="col.dataField"
      :caption="col.caption"
    />
  </DxDataGrid>
  <p v-if="!loading && !rows.length" class="empty-hint">Нет данных для отображения</p>
</template>

<style scoped>
.empty-hint {
  margin: 12px 0 0;
  color: #888;
  font-size: 13px;
}
</style>
